module.exports = __webpack_public_path__ + "static/media/voicemailsPageDemo.1fbb7ed1.gif";